import { Station } from '@app/core/types/stations';
import { auditScheduleAuditSchedulesGet } from '@mi-front/api-v2';
import { AuditSchedule } from '@mi-front/core';
import { AsyncChildProps, AsyncView } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { SchedulesViewViewP } from './view_p';

interface Props {
  readonly station: Station;
  readonly scheduleId: string;
}

/**
 * Loads a single schedule (with audio + matches) via api-v2 and renders the detail view.
 */
export function SchedulesViewView(p: Props) {
  const { $t } = useIntl();

  return (
    <AsyncView
      promiseFn={async () => {
        // OpenAPI Get schema only documents joins; runtime returns the full schedule.
        const data = await auditScheduleAuditSchedulesGet(p.scheduleId);
        return data as unknown as AuditSchedule;
      }}
      query={{}}
      silent
      loader={$t({
        id: 'audit.schedulesViewScreen.loading',
        defaultMessage: 'Cargando schedule',
      })}
    >
      {(vp: AsyncChildProps<AuditSchedule>) => (
        <SchedulesViewViewP
          data={{
            station: p.station,
            schedule: vp.data,
          }}
        />
      )}
    </AsyncView>
  );
}
